import React, { useState, useCallback, useEffect } from 'react';

import { useAuth, useStore } from 'hooks';
import { WeekdayFormatter } from 'utils/formatter/Date';
import { useCardapioContext } from 'hooks/Cardapio';
import { useHistory } from 'react-router-dom';

import * as T from './interfaces';
import { PlaceItem } from './PlaceItem';

export const Container = ({ id, place, ...rest }: T.IItem) => {
  const history = useHistory();

  const { user } = useAuth();
  const { setStoreSelected } = useCardapioContext();
  const [isFavorite, setIsFavorite] = useState(false);
  const [currentDay, setCurrentDay] = useState('');
  const [nextTime, setNextTime] = useState('');

  const { handleFavorites, favorites } = useStore();

  useEffect(() => {
    const date = new Date();
    const day = date.getDay();
    const weekday = WeekdayFormatter.numberToStringPT(day);
    const currentNextTime = place.openingHours.find(
      item => item.day === weekday,
    ).hours[place.isOpen ? 'close' : 'open'];
    setNextTime(currentNextTime);
    setCurrentDay(weekday);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsFavorite(() => !!favorites.includes(place.bk_number));
  }, [favorites]);

  const handleShowPin = useCallback(() => {
    console.log(place.id);
  }, [place.id]);

  const handleGoToHub = useCallback(() => {
    console.log(place.id);
  }, [place.id]);

  const handleGPS = useCallback(() => {
    console.log(place.id);
  }, [place.id]);

  const handleSelectStore = useCallback((idStore, nameStore) => {
    history.push('/cardapio');

    setStoreSelected(idStore, nameStore);
  }, []);

  const idItem = `placeItem@${id}`;
  const buttonFavoriteTextProps = {
    id: `favoritePlaceItem@${id}`,
    title: `Marcar como favorito o ${place.name}`,
  };
  const buttonContainerInfoTextProps = {
    id: `hubPlaceItem@${id}`,
    title: `ir para o hub de ${place.name}`,
  };
  const buttonGPSTextProps = {
    id: `placeItemGPS@${id}`,
    title: `Abrir endereço do ${place.name} GPS`,
    logEvent: { logName: '', params: '' },
  };
  const buttonSelectMenuTextProps = {
    id: `selectMenuPlaceItem@${id}`,
    title: `Ir até o cardápio do ${place.name}`,
  };
  const expandTextProps = {
    title: {
      inOpen: `Esconder informações do ${place.name}`,
      inClose: `Expandir informações do ${place.name}`,
    },
    description: {
      inClose: 'Mais informações',
      inOpen: `Esconder informações`,
    },
  };
  return (
    <PlaceItem
      {...rest}
      id={idItem}
      place={place}
      status={{
        current: place.isOpen ? 'active' : 'inactive',
        text: place.isOpen ? 'aberto' : 'fechado',
        nextTime: `${place.isOpen ? 'Fecha' : 'Abre'} às ${nextTime}`,
      }}
      userIsLoggedIn={user?.signed}
      expandTextProps={expandTextProps}
      buttonFavoriteTextProps={buttonFavoriteTextProps}
      buttonContainerInfoTextProps={buttonContainerInfoTextProps}
      buttonGPSTextProps={buttonGPSTextProps}
      buttonSelectMenuTextProps={buttonSelectMenuTextProps}
      isFavorite={isFavorite}
      currentDay={currentDay}
      onClickFavorite={handleFavorites}
      onClickInfo={handleGoToHub}
      onClickGPS={handleGPS}
      onClickSelectPin={handleShowPin}
      onSelectStore={handleSelectStore}
    />
  );
};
